import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FuseSharedModule } from '../../../@fuse/shared.module';
import { FuseConfigService } from '../../../@fuse/services/config/config.service';
// import { FUSE_CONFIG } from '../../../@fuse/services/config/config.constants';
// import { fuseConfigValue } from '../../../@fuse/fuse.config-value';
import { HasPermissionService } from '../../../app/shared/services/service.index';
import { LoginComponent } from '../../../app/main/authentication/login/login.component';
import { ResetPasswordComponent } from '../../../app/main/authentication/resetpassword/resetpassword.component';
import { ConfirmMailComponent } from './confirm-mail/confirmmail.component';
import { appRoutes } from './authentication.route';
import { AuthenticationService } from './authentication.service';
import { AppConfig } from '../../app.config';

/*Directory */
import { CompareDirective } from '../../shared/directives/passwordvalidator.directive';
/*Eof : Directory*/

import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { RecoverSecurityCodeComponent } from './confirm-recover-security-code/recoversecuritycode.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { AcceptTermsAndConditionComponent } from './accept-terms-and-condition/accept-terms-and-condition.component';
import { HasPermissionGuardService } from 'app/shared/guards/auth.guard';
import { MatDividerModule } from '@angular/material/divider';

export const routes = [
  {
    path: 'confirmEmail',
    component: ConfirmMailComponent,
    canActivate: [HasPermissionGuardService]
  },
];

@NgModule({
  declarations: [
    ConfirmMailComponent,
    LoginComponent,
    AcceptTermsAndConditionComponent,
    ResetPasswordComponent,
    RecoverSecurityCodeComponent,
    CompareDirective,
    //TermsConditionComponent,
    ForgotPasswordComponent,
    //PrivacyPolicyComponent
  ],
  imports: [
    RouterModule.forChild(appRoutes),
    CommonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatRadioModule,
    MatIconModule,
    MatInputModule,
    MatSliderModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatCardModule,
    MatSnackBarModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatToolbarModule,
    MatDialogModule,
    MatDividerModule,
    FuseSharedModule
  ],
  exports: [
    LoginComponent,
    ResetPasswordComponent,
    ConfirmMailComponent,
    ForgotPasswordComponent,
    RecoverSecurityCodeComponent,
    AcceptTermsAndConditionComponent,
    CompareDirective,
    //TermsConditionComponent,
    //PrivacyPolicyComponent
  ],
  providers: [AuthenticationService, AppConfig, HasPermissionService,
    // { provide: FUSE_CONFIG, useValue: fuseConfigValue }, 
    FuseConfigService]
})

export class AuthenticationModule {

}
